/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RemoveClientFromMcpServerRequestBody = {
  /**
   * The remote_session_client id.
   */
  clientId: string;
  /**
   * The mcp_server id to detach from.
   */
  mcpServerId: string;
};

/** @internal */
export type RemoveClientFromMcpServerRequestBody$Outbound = {
  client_id: string;
  mcp_server_id: string;
};

/** @internal */
export const RemoveClientFromMcpServerRequestBody$outboundSchema: z.ZodMiniType<
  RemoveClientFromMcpServerRequestBody$Outbound,
  RemoveClientFromMcpServerRequestBody
> = z.pipe(
  z.object({
    clientId: z.string(),
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      clientId: "client_id",
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function removeClientFromMcpServerRequestBodyToJSON(
  removeClientFromMcpServerRequestBody: RemoveClientFromMcpServerRequestBody,
): string {
  return JSON.stringify(
    RemoveClientFromMcpServerRequestBody$outboundSchema.parse(
      removeClientFromMcpServerRequestBody,
    ),
  );
}
